<div class="bk-empty-state">
  <i class="mdi" [ngClass]="icon" aria-hidden="true"></i>
  <span>{{ message }}</span>
  <ng-content></ng-content>
</div>
